<template>
    <div v-if="$auth.check()" class="sidebar" :class="{'collapsed': collapse}">
        <slot>

        </slot>
        <div class="sidebar-contents" :class="{'collapsed': collapse}">
            <router-link :to="{name: 'dashboard'}" class="brand mt-2 mx-auto" target="_self">
                <img src="/images/logo-light.png" alt="Leonards Studio">
            </router-link>

            <div class="filter-links-search-container">
                <i class="fa fa-filter mx-1" style="color:#7d7d7d;" />
                <label for="sidebar_search" class="d-none">Search Links</label>
                <input id="sidebar_search" name="sidebar_search"
                class="filter-links-search"
                type="search"
                @input="filter"
                @focus="setCollapse(false)"
                v-model="filterItems['search']"
                placeholder="Search Tools" autocomplete="off" />
            </div>

            
            <nav id="default-sidebar-nav" class="sidebar-nav mt-3">
                <div v-if="sidebarLinks && sidebarLinks.links && sidebarLinks.links.length > 0">
                    <div v-for="(group) in sidebarLinks.groups" :key="'sidebar_group_' + group.id">
                        <div v-if="group.id != 6" class="nav-group">
                            <small class="nav-header">
                                {{ group.name }}
                            </small>
                        </div>

                        <div v-for="(item) in sidebarLinks.links.filter((el)=>el.group_id == Number(group.id))" :key="'sidebar_link_' + item.id" 
                            v-show="filterItems.results.length == 0 || filterItems.results.includes(item.id)"
                            >
                            <div @click="selectLink(item)" :class="{'router-active': selectedLink == item.id}" class="nav-link cursor-pointer">
                                <i :class="[item.icon, 'nav-icon']"></i>
                                <span>{{item.label}}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </nav>
            
            <!-- NAV LINKS -->
            <!-- <nav id="default-sidebar-nav" class="sidebar-nav">
                <div v-if="links && links.length > 0">
                    <div
                    v-for="(row,index) in links"
                    class="cursor-pointer"
                    @click.prevent="selectLink(row)"
                    v-show="filterItems.results.length == 0 || filterItems.results.includes(row.id)"
                    :key="'sidebarlinks'+index">
                        <div
                        v-if="(index == 0 || links[index]['group'] !== links[index -1]['group']) && checkPermissions(row.group_permission)"
                        class="nav-group">
                            <small class="nav-header">
                                {{row.group == 'main' ? '' : titleCase(row.group)}}
                            </small>
                        </div>

                        <div v-if="checkPermissions(row.permission) && checkPermissions(row.group_permission)">
                            <div class="nav-link"
                            :class="{'router-active': selectedLink == row.id}">
                                <i :class="[row.icon, 'nav-icon']"></i>
                                <span>{{row.label}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </nav> -->
            <!-- NAV LINKS -->

        </div>

        <div class="fixed-item user-block" v-if="hasAccess()" @click.prevent="setCollapse(false)">
            <div class="nav-item dropup">
                <a href="#" class="nav-link d-flex align-items-center dropdown-toggle" data-toggle="dropdown">

                    <div class="position-relative">
                        <i class="fas fa-circle fa-2x" />
                        <div class="first-letter">
                            {{firstLetter}}
                        </div>
                    </div>
                    <div class="hide-small ml-2">
                        {{displayName | titlecase}}
                        <!-- <div class="text-muted font-xs">Click to log out</div> -->
                    </div>
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" :to="{name: 'profile'}">
                        <i class="fas fa-user-circle text-dark nav-icon"></i> My Profile
                    </router-link>
                    <router-link class="dropdown-item" :to="{name: 'feedback'}">
                        <i class="fas fa-question-circle text-dark nav-icon"></i> Send Feedback
                    </router-link>
                    <a class="dropdown-item" href="#" @click.prevent="logout">
                        <i class="fa fa-sign-out-alt text-dark nav-icon"></i> Log Out
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Sidebar from '../../classes/Sidebar'

    export default {
        props: ['collapse'],

        data() {
            return {
                sidebarLinks: null,
                selectedLink: null,
                hoveredLink: null,
                filterItems: {
                    search: '',
                    results: []
                }
            }
        },

        mounted() {
            let self = this;
            this.$auth.ready()
            this.$nextTick(() => {
                self.getSidebarLinks();
            })
            window.events.$on('refreshSidebar', this.getSidebarLinks)
        },

        updated() {
            let self = this;
        },

        beforeDestroy() {
            window.events.$off('refreshSidebar')
        },


        methods: {
            setCollapse(b) {
                this.$emit('setCollapse',b)
            },
            selectLink(link) {
                this.selectedLink = link.id
                this.$router.push(this.routePathOrName(link))
                this.filterItems['search'] = ''
                this.filter()
            },
            routePathOrName(link) {
                if (link.route_name) {
                    return { name : link.route_name }
                }
                else if (link.route_path) {
                    return { path : link.route_path }
                }

                return { path: '/' };
            },

            checkPermissions(permissions) {
                if (!permissions) return true

                var p = permissions.split(',')
                var hasAccess = true
                var self = this
                p.forEach(function(item) {
                    if (!self.permissionCheck(item)) {
                        hasAccess = false
                    }
                })
                return hasAccess
            },

            getSidebarLinks() {
                var _sidebar = new Sidebar()
                var self = this
                self.selectedLink = null
                _sidebar.index().then(function(response) {
                    self.sidebarLinks = response.data
                    setTimeout(() => {
                        self.getActiveLink()
                    },500)
                })
            },

            getActiveLink() {
                var self = this
                //console.log("you are here", self.$route)
                var route = self.$route.name
                var path = self.$route.path
                self.sidebarLinks.links.forEach(row => {
                    if ((row.route_name && row.route_name == route) || (row.route_path && row.route_path == path))
                    {
                        self.selectedLink = row.id
                    }

                    if (!self.selectedLink)
                    {
                        // crawl the route parent tree and find match
                        self.$route.matched.forEach(r => {
                            if ((row.route_name && row.route_name == r.name) || (row.route_path && row.route_path == r.path))
                            {
                                self.selectedLink = row.id
                            }
                        })
                    }

                })
            },

            hasAccess(){
                // check if this user has permission tempteacher.view, if so deny
                // if(this.$auth.check('tempteacher.view')){
                if(this.permissionCheck('tempteacher.view') && !this.$auth.user().roles.includes("System Admin")){
                    return false
                }
                return true
            },

            filter() {
                var search = this.filterItems['search']

                search = search.trim()
                search = search.toLowerCase()
                this.filterItems.results = []
                let self = this
                this.$nextTick(function() {
                    self.sidebarLinks.links.forEach(link => {
                        var label = link['label'] ? link.label.toLowerCase() : ''
                        // var route = link['route_name'] ? link.route_name.toLowerCase() : ''
                        // var path = link['route_path'] ? link.route_path.toLowerCase() : ''
                        if (label.includes(search))
                        {
                            self.filterItems.results.unshift(link.id)
                        }
                    })
                })
            },

            checkAvailableNames() {
                let details = this.$auth.user().details;

                if(details.FirstName !== null && details.FirstName.length > 0) {
                    return details.FirstName + ' ' + details.LastName;
                } else if(details.username !== null && details.username.length > 0) {
                    return details.username;
                } else {
                    return details.emailAddress;
                }
            },

            logout() {
                window.events.$emit('logout');

                // let self = this
                // this.$nextTick(function() {
                //     self.$auth.logout({
                //         makeRequest: true,
                //         redirect: {name: 'login'},
                //     });
                // });
                
                // this.$auth.logout({
                //     success: async function() {
                //         window.events.$emit('logout');
                //     },
                //     error: function(err) {
                //         console.log(err);
                //     }
                // });

            }
        },

        computed: {
            firstLetter() {
                let name = this.checkAvailableNames();
                return name.split('')[0].toUpperCase();
            },

            displayName() {
                let name = this.checkAvailableNames();

                if(name.indexOf('@') !== -1) {
                    return name.split('@')[0];
                } else {
                    return name;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
// Main Layout
$sidebarWidth: 0;
$dark: #313334;

.toggle-area {
    display: none;
    z-index: 1201;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -5px;
    align-items: center;

    button {
        height: 34px;
        width: 12px;
        border: none !important;
        outline: none !important;
        background: var(--dark);
        color: var(--gray);
        border-radius: 7px;
        // border-top-left-radius: 0px !important;
        // border-bottom-left-radius: 0px !important;
        // border-top-right-radius: 7px !important;
        // border-bottom-right-radius: 7px !important;
        box-shadow: 3px 0 7px -1px rgba(0,0,0,0.3);

        &:focus,&:active {
            outline: none;
            border:none;
        }

        &:hover {
            color:var(--light);
        }

        i {
            position: absolute;
            top: 50%;
            left: 2px;
            transform: translateY(-50%);
        }
    }
}

.first-letter {
    top: 50%;
    left: 50%;
    z-index: 100;
    font-size: 1.7rem;
    transform: translate(-50%, -50%);
    line-height: 1.7rem;
    margin: 0px;
    color: var(--dark);
    padding: 0px;
    font-weight: 700;
    position: absolute;
    padding-bottom: 4px;
}

.sidebar-contents {
    width: 200px;
    background: $dark;
    overflow:hidden;
}

.sidebar {
    position: fixed;
    height: calc(100vh - 50px);
    top: 50px;
    //transition: width 0.24s ease;
    box-shadow: 4px 4px 4px -1px rgba(0,0,0,0.15);
    z-index: 2000;

    .filter-links-search-container {
        border-bottom: 1px solid #7d7d7d;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        padding: 0 2px;
        margin: 10px 5px 6px 5px;
        display:flex;
        align-items:baseline;

        &:focus-within, &:active {
            background: rgba(255,255,255,0.08);
        }
    }

    .filter-links-search {
        border: none;
        background: none;
        margin-bottom: 4px;
        padding: 3px;
        color: #dadada;
    }

    .brand {
        display: none;
        height: 54px;

        img {
            transition: width 0.2 ease;
        }
    }

    .sidebar-nav {
        height: calc(100vh - 162px);

        .nav-group {
            padding: 0.75rem 0.75em 0;

            small {
                font-weight: bold;
                letter-spacing: 0.1em;
            }
        }

        .nav {
            padding: 0 0.75em;
        }

        .nav-header {
            color: #9f9f9f;
            text-transform: uppercase;
            font-weight: 500 !important;
            width: 100%;
            display: block;
            font-size: 0.72rem;
            margin-bottom: 2px;
        }

        .nav-link {
            color: rgba(255,255,255,0.7);
            position: relative;
            width: 100%;
            display: flex;
            align-items: center;
            //margin-bottom: 0.25rem;

            font-size: 95%;
            padding: 0.43rem 0.65rem;
            border-radius: 0;

            .nav-icon {
                color: #a6aaae;
                font-size: 0.93rem;
            }

            &:hover, &.router-active {
                color: #fff;
                font-weight:500;
                background: rgba(255,255,255,0.1);
                //transition: all 0.2s ease-in;

                .nav-icon {
                    color: #fff;
                }
            }

        }
    }

    .fixed-item {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }
}

.user-block {
    background-color:#212529;

    .nav-link {
        padding: 0.5rem 1rem;
        height: auto !important;

        &:hover {
            background-color: #4d5154;
            top: 2px;
        }
    }

    &:before {
        position: absolute;
        content: '';
        top: 0;
        height: 2px;
        left: 0;
        right: 0;
        background: darken($dark, 15%);
        border-bottom: 1px solid lighten($dark, 15%);
    }

    i {
        position: relative;
    }
}

.dropup {
    .dropdown-toggle::after {
        display: block;
        margin-left: auto;
    }

    .dropdown-menu {
        width: 95%;
    }
}

/* scrollbar */
/* https://gist.github.com/howar31/127f71018a9ef025291f9c76293972ea */
.sidebar-nav::-webkit-scrollbar {
	width: 14px;
}
.sidebar-nav::-webkit-scrollbar-thumb {
	background-clip: content-box;
	border: 4px solid transparent;
	border-radius: 10px;
	box-shadow: inset 0 0 0 10px;
}
.sidebar-nav::-webkit-scrollbar-button {
	width: 0;
	height: 0;
	display: none;
}
.sidebar-nav::-webkit-scrollbar-corner {
	background-color: transparent;
}
.sidebar-nav {
	overflow-y: auto;
    overflow-x: hidden;
	color: rgb(73, 73, 73);
	//transition: color 0.3s;

	&:hover {
		color: #81868b;
	}
}
/* end scrollbar */

@media (min-width: 640px) {
    .sidebar {



    }
}

//@include media-breakpoint-up(md) {
@media (min-width: 991.98px) {
    // .sidebar-show {
    //     width: 200px;
    //     visibility: visible;
    // }

    .top-menu-button-container {
        display: none;
    }

    // $sidebarWidth: 200px;

    .sidebar {
        visibility: visible !important;
        height: 100vh;
        top: 0;

        &.collapsed {
            width: 80px !important;
            // overflow: hidden;
        }

        &.collapsed .user-block {
            overflow: hidden !important;
        }

        .toggle-area {
            display: flex;
        }

        .sidebar-contents.collapsed .brand img {
            width: 70px !important;
        }

        .sidebar-contents.collapsed .sidebar-nav {
            width: 80px !important;
        }

        .sidebar-contents.collapsed {
            width: 80px;
            white-space: nowrap;
        }

        .brand {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .sidebar-nav {
            height: calc(100vh - 162px);
        }
    }

}

</style>
